import { Box, Typography } from "@mui/material";
import React from "react";

function Header() {
  return (
    <Box p={2}>
      <Typography variant="h6">Search</Typography>
    </Box>
  );
}

export default Header;
